import { AssetType } from "@zapier/canvas-state";
import { Icon, Tag, Text, Button } from "@zapier/design-system";

import capitalizeFirstLetter from "../../utils/capitalizeFirstLetter";

import styles from "./AssetDetailModal.module.css";

interface ModalContainerProps {
  assetType: AssetType;
  onOverlayClick: (e: React.MouseEvent) => void;
  title: string;
  url: string | undefined;
  disableIframe?: boolean;
}

export function ModalContainer({
  onOverlayClick,
  title,
  url,
  assetType,
  disableIframe = false,
}: ModalContainerProps) {
  // Prevent any clicks from reaching the iframe
  const handleIframeContainerClick = (
    e: React.MouseEvent | React.KeyboardEvent,
  ) => {
    if (disableIframe) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
    <div className={styles.overlay} onClick={onOverlayClick}>
      <div
        className={`${styles.modalContainer} ${styles.modalContainerMaximized}`}
      >
        <div className={styles.header}>
          <div className={styles.leftElements}>
            <Icon name={getIconName(assetType)} color="BrandOrange" />
            <Text type="Body3">
              {capitalizeFirstLetter(assetType || "Asset")}
            </Text>
            <Tag>View Only</Tag>
          </div>
          <span>
            <Button href={url} target="_blank" color="brand">
              Go to {capitalizeFirstLetter(assetType || "Asset")}
            </Button>
          </span>
        </div>
        <div
          className={styles.contentContainer}
          onClick={handleIframeContainerClick}
          onMouseDown={handleIframeContainerClick}
          onMouseUp={handleIframeContainerClick}
          onKeyDown={handleIframeContainerClick}
          role="presentation"
          tabIndex={-1}
        >
          {disableIframe && (
            <div
              className={styles.iframeOverlay}
              onClick={(e) => e.stopPropagation()}
              onMouseDown={(e) => e.stopPropagation()}
              onMouseUp={(e) => e.stopPropagation()}
              onKeyDown={(e) => e.stopPropagation()}
              role="presentation"
              tabIndex={-1}
            />
          )}
          <iframe
            title={title}
            src={url}
            className={styles.iframe}
            style={{ pointerEvents: disableIframe ? "none" : "initial" }}
            sandbox={
              disableIframe ? "allow-same-origin allow-scripts" : undefined
            }
          />
        </div>
      </div>
    </div>
  );
}

function getIconName(assetType: AssetType) {
  switch (assetType) {
    case "zap":
      return "miscBoltAltFill";
    case "interface":
      return "navInterfaces";
    case "table":
      return "navTables";
    case "chatbot":
      return "navAIChatbot";
    default:
      return "miscBoltAltFill";
  }
}
